import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '@/features/account';

export const Route = createFileRoute('/_auth/me/profile')({
  component: ProfilePage,
});
